import { API_URLS } from 'constants/apiUrls';
import { IHeaderDecorator } from 'decorators/HeaderDecorator';
import { ITranslationsParams, ITranslationsResponse } from './interfaces';

export default class TranslationsRepository {
    constructor(private readonly httpClient: IHeaderDecorator) {}

    public fetch = (): Promise<ITranslationsResponse> =>
        this.httpClient.get<ITranslationsResponse, ITranslationsParams>(API_URLS.TRANSLATIONS);
}
